import React, { Component } from 'react'

const AdminHeader = () => {
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/admin";
  };
  return (
    <div>
      <style>
        {`
          .nav-link:hover  {
            // background-color: transparent !important;
            color: inherit !important;
            box-shadow: none !important;
          }
            .main-header .nav-link{
            // height: inherit;
            }

            a{
            text-decoration: none;
            }
            
            .nav-link:hover {       
            transform: inherit;
            animation: inherit;
            color: #fff !important;
            }
            .nav-link{
                font-size: 12px;
            text-align: inherit;
            transition: inherit;
            margin: inherit;
            display: inherit;
               
            
            }

          

          .nav-link.active {
            color: black !important;
            }
            .logout-button, .logout-button-icon{
            color: black !important;
            }
            .logout-button:hover, .logout-button-icon:hover{
            color: black !important;
            }
         
          .sidebar{
            height: 80vh !important;
            overflow: scroll;
            overflow-x: hidden;
          }

          .position-fixed{
            position: fixed;
          }

          .school-block {
            background: rgba(48, 50, 54, 0.88);
            border-radius: 6px;
            box-shadow: 0 0.46875rem 2.1875rem rgba(90,97,105,0.1), 0 0.9375rem 1.40625rem rgba(90,97,105,0.1), 0 0.25rem 0.53125rem rgba(90,97,105,0.12), 0 0.125rem 0.1875rem rgba(90,97,105,0.1);
            margin: 3px;
            padding: 2px 0;
            border-bottom: 2px solid rgba(239, 234, 234, 0.96);
          }

          .under-school-block {
            background: rgba(48, 50, 54, 0.88);
            border-radius: 6px;
            box-shadow: 0 0.46875rem 2.1875rem rgba(90,97,105,0.1), 0 0.9375rem 1.40625rem rgba(90,97,105,0.1), 0 0.25rem 0.53125rem rgba(90,97,105,0.12), 0 0.125rem 0.1875rem rgba(90,97,105,0.1);
            margin: 3px;
            padding: 2px 0;
          }
          .school-block-border {
            border-left: 2px solid rgba(241, 236, 236, 0.69);
          }

        `}
      </style>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        {/* Left navbar links */}
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link logout-button-icon" data-widget="pushmenu" href="#"><i className="fas fa-bars" /></a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <button
              type="button"
              className="nav-link btn logout-button"
              onClick={handleLogout}
              style={{ color: "black !important" }}
            >
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default AdminHeader;